module.exports = __webpack_public_path__ + "a768e7de/img/chevron-down-icon.5542f65c.svg";